module.exports = {};



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_iterators.js
// module id = 305
// module chunks = 0